import React from "react";
import { Alert, Box, CardContent, Chip, Grid, LinearProgress, Typography } from "@mui/material";
import SectionHeader from "../components/common/SectionHeader";
import { marketDataApi } from "../services/marketDataApi";
import AccentCard from "../components/common/AccentCard";

const DiscoverPage = () => {
  const { data: assets = [], isLoading, error } = marketDataApi.endpoints.getAllMarketAssets.useQuery();

  const topGainers = React.useMemo(
    () => [...assets].sort((a, b) => Number(b.priceChangePercentage24h || 0) - Number(a.priceChangePercentage24h || 0)).slice(0, 6),
    [assets]
  );

  const topLosers = React.useMemo(
    () => [...assets].sort((a, b) => Number(a.priceChangePercentage24h || 0) - Number(b.priceChangePercentage24h || 0)).slice(0, 6),
    [assets]
  );

  if (isLoading) return <LinearProgress />;
  if (error) return <Alert severity="error">Failed to load discover feed.</Alert>;

  const renderList = (title, list, color) => (
    <AccentCard variant="outlined" sx={{ borderRadius: 2, height: "100%" }}>
      <CardContent>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
          {title}
        </Typography>
        {list.map((asset) => (
          <Box
            key={asset.marketAssetId}
            sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", py: 0.75 }}
          >
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 700 }}>{asset.symbol}</Typography>
              <Typography variant="caption" color="text.secondary">{asset.name}</Typography>
            </Box>
            <Chip
              size="small"
              color={color}
              label={`${Number(asset.priceChangePercentage24h || 0).toFixed(2)}%`}
            />
          </Box>
        ))}
      </CardContent>
    </AccentCard>
  );

  return (
    <Box sx={{ width: "100%", minWidth: 0 }}>
      <SectionHeader variant="h4" component="h1" gutterBottom sx={{ pb: 0.75 }}>
        Discover
      </SectionHeader>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
        Quickly scan top movers and trending market opportunities.
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>{renderList("Top Gainers (24h)", topGainers, "success")}</Grid>
        <Grid size={{ xs: 12, md: 6 }}>{renderList("Top Losers (24h)", topLosers, "error")}</Grid>
      </Grid>
    </Box>
  );
};

export default DiscoverPage;
